module.exports = __webpack_public_path__ + "img/ss-a.7ee2a467.svg";